/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BookingRequestModel } from '../../models/booking-request-model';

export interface ConsumerCreateEventPractitionerRoleIdPost$Params {
  practitionerRoleId: string;
      body?: BookingRequestModel
}

export function consumerCreateEventPractitionerRoleIdPost(http: HttpClient, rootUrl: string, params: ConsumerCreateEventPractitionerRoleIdPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, consumerCreateEventPractitionerRoleIdPost.PATH, 'post');
  if (params) {
    rb.path('practitionerRoleId', params.practitionerRoleId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as CalendarStrictHttpResponse<void>;
    })
  );
}

consumerCreateEventPractitionerRoleIdPost.PATH = '/Consumer/CreateEvent/{practitionerRoleId}';
